import { combineActions, handleActions } from 'redux-actions';
import { capabilityUtils } from 'moet-core';
import _isEqual from 'lodash/isEqual';

import { CAPS, PRODUCT_SELECTION_CLEAR_ERRORS } from '../constants';

const init = {
  expandedProductId: 'kco',
  selectedProductId: null,
  selectedProductOptionIds: [],
  data: [],
  error: null,
};

const merchantUpdateProductActionsV2 = capabilityUtils.getFinalizedActions([
  CAPS.V2_MERCHANTS_PRODUCTS_PUT,
  CAPS.V2_MERCHANTS_ADDITIONAL_PRODUCTS_POST,
  CAPS.V2_MERCHANTS_GET,
]);

const merchantUpdateProductActionsV2Loading = capabilityUtils.getFinalizedActions([
  CAPS.V2_MERCHANTS_PRODUCTS_PUT.LOADING,
  CAPS.V2_MERCHANTS_ADDITIONAL_PRODUCTS_POST.LOADING,
  CAPS.V2_MERCHANTS_GET.LOADING,
]);

export default handleActions(
  {
    [combineActions(...merchantUpdateProductActionsV2Loading)]: (state, { error, payload }) => {
      return {
        ...state,
        error: null,
      };
    },
    [combineActions(...merchantUpdateProductActionsV2)]: (state, { error, payload }) => {
      if (error) {
        console.error('Error while trying to select products: ', payload);
        return {
          ...state,
          error,
        };
      }

      const { products = [] } = payload.data;

      const product = products.find(
        ({ status, options }) => status || options.find(({ status }) => status),
      );
      let updatedProductState = {
        expandedProductId: 'kco',
        selectedProductId: null,
        selectedProductOptionIds: [],
      };
      if (product) {
        updatedProductState = {
          selectedProductId: product.id,
          expandedProductId: product.id,
          selectedProductOptionIds: product.options
            .filter(({ status }) => status)
            .map(p => {
              return {
                ...p,
                checked: true,
              };
            }),
        };
      }

      return {
        ...state,
        ...updatedProductState,
      };
    },
    [CAPS.V2_PRODUCTS_GET]: (state, { error, payload }) => {
      if (error) {
        return state;
      }

      // we don't need to set the data property again on the state if they have the SAME result
      // as this causes a rerender because the object reference changes
      // (even if the content doesn't)
      if (_isEqual(state.data, payload.data)) {
        return state;
      }
      return {
        ...state,
        data: payload.data,
      };
    },
    [PRODUCT_SELECTION_CLEAR_ERRORS]: state => {
      return {
        ...state,
        error: null,
      };
    },
  },
  init,
);
